module.exports = __webpack_public_path__ + "img/icon--camera.ceba6ed4.svg";